import InfoPopup from "components/InfoPopup"
import { useFormik } from "formik"
import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import * as Yup from "yup"
import { Button, Card, CardBody, Form } from "reactstrap"
import ErrorPopup from "components/ErrorPopup"
import { UPDATE_PVS_REGISTRATION_RESET } from "../../../redux/types/pvs"
import { updatePvsRegistration } from "../../../redux/actions/pvs"
import { toast } from "react-toastify"

const Step2 = props => {
  const dispatch = useDispatch()
  const [isErrorOpen, setIsErrorOpen] = useState(false)
  const [isErrorMessage, setIsErrorMessage] = useState("")
  const [previewOpen, setPreviewOpen] = useState(false)
  const [previewFile, setPreviewFile] = useState(null)

  const pvsFormData = useSelector(state => state.pvs.pvsFormData)
  const updatePvsRegistrationScreen = useSelector(
    state => state.screens.pvs.updatePvsRegistration
  )

  useEffect(() => {
    if (updatePvsRegistrationScreen.success && props.activeTab === 2) {
      // toast.success(updatePvsRegistrationScreen.message)
      dispatch({ type: UPDATE_PVS_REGISTRATION_RESET })
      props.toggleTab(props.activeTab + 1)
    }
    if (updatePvsRegistrationScreen.error && props.activeTab === 2) {
      setIsErrorMessage(updatePvsRegistrationScreen.error)
      setIsErrorOpen(true)
      dispatch({ type: UPDATE_PVS_REGISTRATION_RESET })
    }
  }, [updatePvsRegistrationScreen])

  useEffect(() => {
    if (pvsFormData) {
      if (pvsFormData.aadhar_card_img) {
        convertUrlToBlob(
          "aadharFront",
          pvsFormData.aadhar_card_img,
          pvsFormData.aadhar_card_img_path
        )
      }
      if (pvsFormData.aadhar_card_img_back) {
        convertUrlToBlob(
          "aadharBack",
          pvsFormData.aadhar_card_img_back,
          pvsFormData.aadhar_card_img_back_path
        )
      }
      if (pvsFormData.permanent_address_img) {
        convertUrlToBlob(
          "permanentAddressProof",
          pvsFormData.permanent_address_img,
          pvsFormData.permanent_address_img_path
        )
      }
      if (pvsFormData.pune_address_img) {
        convertUrlToBlob(
          "puneAddressProof",
          pvsFormData.pune_address_img,
          pvsFormData.pune_address_img_path
        )
      }
    }
  }, [pvsFormData])

  const togglePreview = () => setPreviewOpen(!previewOpen)

  const openPreview = file => {
    setPreviewFile(file)
    setPreviewOpen(true)
  }

  const formik = useFormik({
    initialValues: {
      aadharFront: null,
      aadharBack: null,
      permanentAddressProof: null,
      puneAddressProof: null,
    },
    validationSchema: Yup.object({
      aadharFront: Yup.mixed().required("Aadhaar Front is required"),
      aadharBack: Yup.mixed().required("Aadhaar Back is required"),
      permanentAddressProof: Yup.mixed().required(
        "Permanent Address Proof is required"
      ),
      puneAddressProof: Yup.mixed().required("Pune Address Proof is required"),
    }),
    onSubmit: values => {
      console.log("values", values)
      const formData = new FormData()
      formData.append("step", "2")
      formData.append("pvs_entry_id", pvsFormData.pvs_entry_id)
      formData.append("aadhar_card_img", values.aadharFront.file)
      formData.append("aadhar_card_img_back", values.aadharBack.file)
      formData.append(
        "permanent_address_img",
        values.permanentAddressProof.file
      )
      formData.append("pune_address_img", values.puneAddressProof.file)
      console.log("formData...", formData)

      dispatch(updatePvsRegistration(formData))
    },
  })

  useEffect(() => {
    console.log("formik values", formik.values)

    if (formik.isSubmitting && formik.errors) {
      formik.setSubmitting(false)
      if (Object.keys(formik.errors).length > 0) {
        let message = (
          <div>
            <ul className="mb-0 ps-3">
              {Object.keys(formik.errors).map(key => (
                <li key={key} className="mb-3">
                  {formik.errors[key]}
                </li>
              ))}
            </ul>
          </div>
        )

        console.log("message..", message)

        setIsErrorMessage(message)
        setIsErrorOpen(true)
      }
    }
  }, [formik])

  async function convertUrlToBlob(fieldName, filename, url) {
    // Fetch the image data from the URL
    const response = await fetch(url)

    // Get the response data as a Blob
    const blob = await response.blob()

    // Determine the file type (MIME type) from the blob
    // Fallback to a default type if the response doesn't provide one
    const type = blob.type || "image/jpeg" //

    // Create a new File object using the Blob, filename, and type
    const file = new File([blob], filename, { type })

    console.log("file..", file)

    formik.setFieldValue(fieldName, {
      file,
      name: file.name,
      type: file.type,
      url: URL.createObjectURL(file),
    })
  }

  function onSelectFile(event, fieldType) {
    console.log("files", event.target.files)

    const file = event.target.files[0]
    if (!file) return

    const supported = ["image/jpeg", "image/png", "image/jpg"]
    if (!supported.includes(file.type)) {
      alert("Please upload an image file (jpeg, jpg, png)")
      return
    }
    const previewUrl = URL.createObjectURL(file)
    formik.setFieldValue(fieldType, {
      file,
      name: file.name,
      type: file.type,
      url: previewUrl,
    })
  }

  return (
    <>
      <Form onSubmit={formik.handleSubmit}>
        <Card>
          <CardBody>
            <h4 className="nom-title mb-3">Upload Documents</h4>
            <p className="text-muted small mb-4">
              Note: Upload files up to 5 MB in JPG, JPEG, PNG, or PDF format.
            </p>
            <div className="mb-4">
              <div className="mb-4">
                <h5 className="h6 mb-0">
                  Aadhaar (Front) <span style={{ color: "red" }}>*</span>
                </h5>
              </div>
              {formik.values.aadharFront ? (
                <div className="d-flex justify-content-between align-items-center flex-wrap gap-3 p-3 rounded-3 border">
                  <div className="d-flex align-items-center gap-3">
                    <span
                      className="rounded-circle d-inline-flex align-items-center justify-content-center"
                      style={{
                        width: 32,
                        height: 32,
                        background: "#e7f6ef",
                      }}
                    >
                      <i className="mdi mdi-check text-success" />
                    </span>
                    <div>
                      <h6 className="mb-0">{formik.values.aadharFront.name}</h6>
                    </div>
                  </div>
                  <div className="d-flex align-items-center gap-3 text-primary">
                    <button
                      type="button"
                      className="btn btn-link text-decoration-none p-0"
                      onClick={() => openPreview(formik.values.aadharFront)}
                    >
                      View
                    </button>
                    <button
                      type="button"
                      className="btn btn-link text-danger text-decoration-none p-0"
                      onClick={() => formik.setFieldValue("aadharFront", null)}
                    >
                      <i className="mdi mdi-trash-can-outline fs-5" />
                    </button>
                  </div>
                </div>
              ) : (
                <>
                  <div
                    className="rounded-3 text-center py-5 px-3"
                    style={{
                      border: "2px dashed #d6d6d6",
                      background: "#fcfcfc",
                      color: "#a5a5a5",
                    }}
                    onClick={() =>
                      document.getElementById("aadharFront").click()
                    }
                  >
                    <i className="mdi mdi-cloud-upload-outline display-6 d-block mb-2" />
                    <p className="mb-0 fw-medium">
                      Click here to upload the file
                    </p>
                    <input
                      type="file"
                      className="hidden"
                      onChange={e => onSelectFile(e, "aadharFront")}
                      id="aadharFront"
                    />
                  </div>
                  {formik.errors.aadharFront && (
                    <div className="text-danger small mt-1">
                      {formik.errors.aadharFront}
                    </div>
                  )}
                </>
              )}
            </div>
            <div className="mb-4">
              <div className="d-flex justify-content-between flex-wrap gap-3 mb-3">
                <div>
                  <h6 className="mb-1">
                    Aadhaar (Back) <span style={{ color: "red" }}>*</span>
                  </h6>
                </div>
              </div>

              {formik.values.aadharBack ? (
                <div className="d-flex justify-content-between align-items-center flex-wrap gap-3 p-3 rounded-3 border">
                  <div className="d-flex align-items-center gap-3">
                    <span
                      className="rounded-circle d-inline-flex align-items-center justify-content-center"
                      style={{ width: 32, height: 32, background: "#e7f6ef" }}
                    >
                      <i className="mdi mdi-check text-success" />
                    </span>
                    <div>
                      <h6 className="mb-0">{formik.values.aadharBack.name}</h6>
                    </div>
                  </div>
                  <div className="d-flex align-items-center gap-3 text-primary">
                    <button
                      type="button"
                      className="btn btn-link text-decoration-none p-0"
                      onClick={() => openPreview(formik.values.aadharBack)}
                    >
                      View
                    </button>
                    <button
                      type="button"
                      className="btn btn-link text-danger text-decoration-none p-0"
                      onClick={() => formik.setFieldValue("aadharBack", null)}
                    >
                      <i className="mdi mdi-trash-can-outline fs-5" />
                    </button>
                  </div>
                </div>
              ) : (
                <>
                  <div
                    className="rounded-3 text-center py-5 px-3"
                    style={{
                      border: "2px dashed #d6d6d6",
                      background: "#fcfcfc",
                      color: "#a5a5a5",
                    }}
                    onClick={() =>
                      document.getElementById("aadharBack").click()
                    }
                  >
                    <i className="mdi mdi-cloud-upload-outline display-6 d-block mb-2" />
                    <p className="mb-0 fw-medium">
                      Click here to upload the file
                    </p>
                    <input
                      type="file"
                      className="hidden"
                      onChange={e => onSelectFile(e, "aadharBack")}
                      id="aadharBack"
                    />
                  </div>
                  {formik.errors.aadharBack && (
                    <div className="text-danger small mt-1">
                      {formik.errors.aadharBack}
                    </div>
                  )}
                </>
              )}
            </div>
            <div className="mb-4">
              <div className="d-flex justify-content-between flex-wrap gap-3 mb-3">
                <div>
                  <h6 className="mb-1">
                    Permanent Address Proof{" "}
                    <span style={{ color: "red" }}>*</span>
                  </h6>
                </div>
              </div>

              {formik.values.permanentAddressProof ? (
                <div className="d-flex justify-content-between align-items-center flex-wrap gap-3 p-3 rounded-3 border">
                  <div className="d-flex align-items-center gap-3">
                    <span
                      className="rounded-circle d-inline-flex align-items-center justify-content-center"
                      style={{ width: 32, height: 32, background: "#e7f6ef" }}
                    >
                      <i className="mdi mdi-check text-success" />
                    </span>
                    <div>
                      <h6 className="mb-0">
                        {formik.values.permanentAddressProof.name}
                      </h6>
                    </div>
                  </div>
                  <div className="d-flex align-items-center gap-3 text-primary">
                    <button
                      type="button"
                      className="btn btn-link text-decoration-none p-0"
                      onClick={() =>
                        openPreview(formik.values.permanentAddressProof)
                      }
                    >
                      View
                    </button>
                    <button
                      type="button"
                      className="btn btn-link text-danger text-decoration-none p-0"
                      onClick={() =>
                        formik.setFieldValue("permanentAddressProof", null)
                      }
                    >
                      <i className="mdi mdi-trash-can-outline fs-5" />
                    </button>
                  </div>
                </div>
              ) : (
                <>
                  <div
                    className="rounded-3 text-center py-5 px-3"
                    style={{
                      border: "2px dashed #d6d6d6",
                      background: "#fcfcfc",
                      color: "#a5a5a5",
                    }}
                    onClick={() =>
                      document.getElementById("permanentAddressProof").click()
                    }
                  >
                    <i className="mdi mdi-cloud-upload-outline display-6 d-block mb-2" />
                    <p className="mb-0 fw-medium">
                      Click here to upload the file
                    </p>
                    <input
                      type="file"
                      className="hidden"
                      onChange={e => onSelectFile(e, "permanentAddressProof")}
                      id="permanentAddressProof"
                    />
                  </div>
                  {formik.errors.permanentAddressProof && (
                    <div className="text-danger small mt-1">
                      {formik.errors.permanentAddressProof}
                    </div>
                  )}
                </>
              )}
            </div>
            <div className="mb-4">
              <div className="d-flex justify-content-between flex-wrap gap-3 mb-3">
                <div>
                  <h6 className="mb-1">
                    Pune Address Proof <span style={{ color: "red" }}>*</span>
                  </h6>
                </div>
              </div>

              {formik.values.puneAddressProof ? (
                <div className="d-flex justify-content-between align-items-center flex-wrap gap-3 p-3 rounded-3 border">
                  <div className="d-flex align-items-center gap-3">
                    <span
                      className="rounded-circle d-inline-flex align-items-center justify-content-center"
                      style={{ width: 32, height: 32, background: "#e7f6ef" }}
                    >
                      <i className="mdi mdi-check text-success" />
                    </span>
                    <div>
                      <h6 className="mb-0">
                        {formik.values.puneAddressProof.name}
                      </h6>
                    </div>
                  </div>
                  <div className="d-flex align-items-center gap-3 text-primary">
                    <button
                      type="button"
                      className="btn btn-link text-decoration-none p-0"
                      onClick={() =>
                        openPreview(formik.values.puneAddressProof)
                      }
                    >
                      View
                    </button>
                    <button
                      type="button"
                      className="btn btn-link text-danger text-decoration-none p-0"
                      onClick={() =>
                        formik.setFieldValue("puneAddressProof", null)
                      }
                    >
                      <i className="mdi mdi-trash-can-outline fs-5" />
                    </button>
                  </div>
                </div>
              ) : (
                <>
                  <div
                    className="rounded-3 text-center py-5 px-3"
                    style={{
                      border: "2px dashed #d6d6d6",
                      background: "#fcfcfc",
                      color: "#a5a5a5",
                    }}
                    onClick={() =>
                      document.getElementById("puneAddressProof").click()
                    }
                  >
                    <i className="mdi mdi-cloud-upload-outline display-6 d-block mb-2" />
                    <p className="mb-0 fw-medium">
                      Click here to upload the file
                    </p>
                    <input
                      type="file"
                      className="hidden"
                      onChange={e => onSelectFile(e, "puneAddressProof")}
                      id="puneAddressProof"
                    />
                  </div>
                  {formik.errors.puneAddressProof && (
                    <div className="text-danger small mt-1">
                      {formik.errors.puneAddressProof}
                    </div>
                  )}
                </>
              )}
            </div>
          </CardBody>
        </Card>
        <div className="pvs-reg-actions actions">
          <div className="btngroup-pvs">
            <div>
              <Button
                color="primary"
                size="md"
                disabled={props.activeTab === 1}
                onClick={() => {
                  props.toggleTab(props.activeTab - 1)
                }}
              >
                <i className="dripicons-arrow-thin-left"></i>
                <span>Previous</span>
              </Button>
            </div>
            <div>
              <Button color="primary" size="md" type="submit">
                <span>
                  {props.activeTab === 5 ? "Submit" : "Save & Continue"}
                </span>
                <i className="dripicons-arrow-thin-right"></i>
              </Button>
            </div>
          </div>
        </div>
      </Form>
      <InfoPopup
        size="lg"
        isOpen={previewOpen}
        toggle={togglePreview}
        title="Document Preview"
        previewFile={previewFile}
      />
      <ErrorPopup
        isOpen={isErrorOpen}
        toggle={() => setIsErrorOpen(!isErrorOpen)}
        title="Fix following errors"
        message={isErrorMessage}
      />
    </>
  )
}

export default Step2
